/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/reInviteUser.config.json";
import notification from "../config/notifications.config.json";
import { VApplication } from "../../../application";
import { AppNavigatorService } from "../../appNavigatorService";
import { GET_MASQUERADER_COUNT } from "../graphql/getUserAdvancedSearchBox.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

import axios from "axios";

export interface IBoxCountUserMethods extends IPluginMethodMap {
  getBoxCountUser(args: any): Promise<any>;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const LoginPageServ = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export class BoxCountUserService implements IAgentPlugin {
  readonly methods: IBoxCountUserMethods;

  constructor() {
    this.methods = {
      getBoxCountUser: this.getBoxCountUser.bind(this),
    };
  }

  async getBoxCountUser(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const srv = LoginPageServ();
    console.log(args);
    try {
      const res = await client.query({
        query: GET_MASQUERADER_COUNT,
        variables: {
          filter: {
            User____id: {
              eq: args?.userId,
            },
          },
        },
        fetchPolicy: "network-only",
      });
      if (res?.data) {
        // const activeCount = res?.data?.getUserAdvancedSearch?.content.filter(
        //   item => item.presentation.status === "active"
        // ).length;
        const activeCount = res?.data?.getUserAdvancedSearch?.count;
        console.log(activeCount);
        return activeCount ?? 0;
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
